import * as React from 'react';
import { ClassableProps, baseClassAnd } from "@jcharlesworthuk/your-mum-core/dist/functions";

const CheckboxSvg: React.FunctionComponent<ClassableProps> = props => {
  return <svg viewBox='0 0 20 20' className={baseClassAnd('checkbox-svg', props)}>
    <path d='M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z'></path>
    <polyline points='4 11 8 15 16 6'></polyline>
  </svg>
}

export default CheckboxSvg;